import { z } from "zod";
import { confirmableConfig, confirmableDefaults } from "./confirmable.js";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  ...confirmableConfig,
});

export const emailField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "email",
  label: "Email address",
  category: "basic_info",
  icon: "Mail",
  configSchema,
  valueSchema: (_config, isRequired) =>
    optionalUnlessRequired(
      z.string().trim().toLowerCase().email("Enter a valid email address"),
      isRequired,
    ),
  defaultConfig: { ...confirmableDefaults },
  supportsProfileBinding: true,
  defaultSearchable: true,
  renderHints: {},
};
